import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Card,
    CardContent, FormControlLabel,
    Stack,
    Typography,
    Radio,
    RadioGroup,
    CircularProgress
} from '@mui/material';
import Box from '@mui/material/Box';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import FormProvider, { RHFAutocomplete } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import { MultiFilePreview, Upload } from 'src/components/upload';
import { baseURLnav } from 'src/config-global';
import { getRequestStart, postRequest, postRequestStart } from 'src/services';
import * as Yup from 'yup';

const TradeWorkTitleCreatePage = () => {

    const [ counties, setCounties ] = useState([]);
    const [ states, setStates ] = useState([]);
    const [ constructionTypes, setConstructionTypes ] = useState([]);
    const [ selectedState, setSelectedState ] = useState(null);
    const [ countyCount, setCountyCount ] = useState(0);
    const [ isLoadingCounties, setIsLoadingCounties ] = useState(false);
    const [ selectedStateName, setSelectedStateName ] = useState('');
    const [ searchMethod, setSearchMethod ] = useState('ai');
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isSending, setIsSending ] = useState(false);
    const [ resultFile, setResultFile ] = useState(null);
    const [ fileDownloadUrl, setFileDownloadUrl ] = useState('');
    const [ fileName, setFileName ] = useState('');
    const [ isSubmitted, setIsSubmitted ] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [ projectId, setProjectId ] = useState(null);


    useEffect(() => {
        // Parse URL search params to get project_id
        const queryParams = new URLSearchParams(location.search);
        const urlProjectId = queryParams.get('project_id');
        if (urlProjectId) {
            setProjectId(urlProjectId);
        }
    }, [ location.search ]);



    useEffect(() => {
        getStates();
        getConstructionTypes();
    }, []);

    useEffect(() => {
        if (selectedState) {
            getCounties(selectedState);
        }
    }, [ selectedState ]);
    const getStates = async () => {
        try {
            const data = await getRequestStart(`/api/states`);
            if (data) {
                setStates(data?.data?.states || []);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };
    const getCounties = async (stateId) => {
        try {
            setIsLoadingCounties(true);
            const data = await getRequestStart(`/api/get-counties?state=${stateId}`);
            if (data) {
                console.log("🚀 ~ getCounties ~ data:", data)
                setCounties(data?.data?.counties || []);
                setCountyCount(data?.data?.count);
            }
        } catch (error) {
            console.error("Error fetching counties:", error);
            setCounties([]);
            setCountyCount(0);
        } finally {
            setIsLoadingCounties(false);
        }
    };
    const getConstructionTypes = async () => {
        try {
            const data = await getRequestStart(`/api/construction-types`);
            if (data) {
                setConstructionTypes(data?.data?.construction_types || []);
            }
        } catch (error) {
            console.error("Error fetching construction types:", error);
        }
    };

    const NewUserSchema = Yup.object().shape({});
    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues: {},
    });

    const { reset, watch, handleSubmit, setValue, formState: { isSubmitting } } = methods;
    const onSubmit = handleSubmit(async (data) => {
        try {
            setIsLoading(true);
            const payload = {
                state: selectedStateName,
                county: data.county,
                construction_type: data.construction_type_id
            };
            const response = await postRequestStart('/api/process-document', payload, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            console.log("🚀 ~ onSubmit ~ response:", response);
            if (response?.data?.structured_data?.csv_file) {
                const downloadUrl = response?.data?.structured_data.csv_file.download_url;
                const filename = response.data.structured_data.csv_file.filename;
                setFileDownloadUrl(downloadUrl);
                setFileName(filename);
                const mockResultFile = new File([ 'dummy content' ], filename, {
                    type: 'text/csv'
                });
                setResultFile(mockResultFile);
                setIsSubmitted(true);
            }
        } catch (err) {
            console.error('Error in catch:', err);
        } finally {
            setIsLoading(false);
        }
    });
    const handleStateChange = (event, value) => {
        setValue('county', null);
        setCounties([]);
        if (value) {
            setSelectedState(value);
            setSelectedStateName(value);
        } else {
            setSelectedState(null);
            setSelectedStateName('');
            setCountyCount(0);
        }
    };
    const handleSearchMethodChange = (event) => {
        setSearchMethod(event.target.value);
    };

    const values = watch();
    const handleDrop = useCallback(
        (acceptedFiles) => {
            setValue('file', acceptedFiles[ 0 ]);
        },
        [ values.file ]
    );

    const handleRemoveFile = () => {
        setValue('file', null);
    };
    const handleDownload = () => {
        if (fileDownloadUrl) {
            const link = document.createElement('a');
            link.href = fileDownloadUrl;
            link.setAttribute('download', fileName || 'wage-determination-results.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };


    const handleSendFile = async () => {
        if (!fileDownloadUrl) return;
        try {
            setIsSending(true);
            const fileResponse = await fetch(fileDownloadUrl);
            if (!fileResponse.ok) {
                throw new Error('Failed to fetch the CSV file');
            }
            const fileBlob = await fileResponse.blob();
            const file = new File([fileBlob], fileName || 'wage-determination-results.csv', {
                type: 'text/csv'
            });
            const formData = new FormData();
            formData.append('csv_file', file);
            const queryParams = new URLSearchParams(location.search);
            const urlProjectId = projectId || queryParams.get('project_id')
            const endpoint = `/import-project/${urlProjectId}/work-trade-titles-ai-csv-file`;
            console.log(`Sending file to endpoint: ${endpoint}`);
    
            const data = await postRequest(endpoint,
                formData,
                true
            );
    
            if (data.metadata) {
                if (data.metadata.success) {
                    const targetUrl = `${baseURLnav}/projects/${urlProjectId}/trade_worker_titles`;
                    enqueueSnackbar({
                        variant: 'success',
                        message: data.metadata.message,
                        autoHideDuration: 1000, // Short duration so it shows briefly before redirect
                        onClose: () => {
                            window.location.href = targetUrl;
                        }
                    });
                    setTimeout(() => {
                        window.location.href = targetUrl;
                    }, 1200);
                } else {
                    handleErrorMessages(data.metadata.message);
                }
            }
        } catch (error) {
            console.error("Error sending CSV file:", error);
            enqueueSnackbar({
                variant: 'error',
                message: 'Failed to upload CSV file: ' + (error.message || 'Unknown error'),
            });
        } finally {
            setIsSending(false);
        }
    };
    const handleViewFile = () => {
        if (fileDownloadUrl) {
            window.open(fileDownloadUrl, '_blank');
        }
    };
    return (
        <div style={ { marginLeft: '14px' } }>
            <Card sx={ { height: '100%', marginTop: '10px', overflow: 'hidden' } }>
                <CardContent>
                    <FormProvider methods={ methods } onSubmit={ onSubmit }>
                        <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' } }>
                            <h2>EZELOGS Wage Determination Lookup Tool</h2>
                        </div>
                        <Box mb={ 3 }>
                            <RadioGroup
                                row
                                value={ searchMethod }
                                onChange={ handleSearchMethodChange }
                                name="search-method"
                            >
                                <FormControlLabel value="ai" control={ <Radio /> } label="Search by AI" />
                                <FormControlLabel value="manual" control={ <Radio /> } label="Manual Upload" />
                            </RadioGroup>
                        </Box>
                        <>
                            <Stack>
                                <Typography variant="h5" sx={ { mb: 2 } }>
                                    <Iconify icon="material-symbols:search" /> Search Parameters
                                </Typography>
                            </Stack>
                            <Box mt={ 2 } rowGap={ 2 } columnGap={ 2 } display="grid" gridTemplateColumns={ { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' } }>
                                <RHFAutocomplete
                                    name="country_id"
                                    label="Country"
                                    options={ [ { id: 1, name: 'United States of America' } ] }
                                    getOptionLabel={ (option) => option.name || '' }
                                    isOptionEqualToValue={ (option, value) => option.id === value?.id }
                                    renderOption={ (props, option) => (
                                        <li { ...props } key={ option.id || '' }>
                                            { option.name }
                                        </li>
                                    ) }
                                />
                                <RHFAutocomplete
                                    name="state_id"
                                    label="State"
                                    options={ states }
                                    getOptionLabel={ (option) => option || '' }
                                    isOptionEqualToValue={ (option) => option }
                                    renderOption={ (props, option) => (
                                        <li { ...props } key={ option.id || '' }>
                                            { option }
                                        </li>
                                    ) }
                                    onChange={ handleStateChange }
                                />
                                <RHFAutocomplete
                                    name="county"
                                    label={ selectedState ? `County (${countyCount} counts)` : "County" }
                                    options={ counties }
                                    getOptionLabel={ (option) => option || '' }
                                    isOptionEqualToValue={ (option, value) => option === value }
                                    renderOption={ (props, option) => (
                                        <li { ...props } key={ option }>
                                            { option }
                                        </li>
                                    ) }
                                    loading={ isLoadingCounties }
                                    disabled={ !selectedState || isLoadingCounties }
                                />
                                <RHFAutocomplete
                                    name="construction_type_id"
                                    label="Construction Types"
                                    options={ constructionTypes }
                                    getOptionLabel={ (option) => option || '' }
                                    isOptionEqualToValue={ (option, value) => option.id === value?.id }
                                    renderOption={ (props, option) => (
                                        <li { ...props } key={ option.id || '' }>
                                            { option }
                                        </li>
                                    ) }
                                />
                            </Box>
                        </>
                        { searchMethod === 'manual' && (
                            <Card sx={ { height: '100%', marginTop: '10px', overflow: 'hidden' } }>
                                <CardContent>
                                    <Typography variant="h5" sx={ { mb: 2 } }>
                                        <Iconify icon="material-symbols:upload" /> Upload File
                                    </Typography>
                                    <Box
                                        mt={ 4 }
                                        rowGap={ 3 }
                                        display="grid"
                                        gridTemplateColumns={ {
                                            xs: 'repeat(1, 1fr)',
                                        } }
                                    >
                                        <Upload onDrop={ handleDrop } onRemove={ handleRemoveFile } isExcelFile={ true } />
                                    </Box>
                                    <Box sx={ { my: 3 } }>
                                        <MultiFilePreview
                                            files={ values?.file ? [ values?.file ] : [] }
                                            onRemove={ handleRemoveFile }
                                            setFileDeleted={ () => { } }
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        ) }
                        <div style={ { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '16px' } }>
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                className="dark-button"
                                loading={ isSubmitting || isLoading }
                                disabled={ isSubmitted }
                            >
                                Submit
                            </LoadingButton>
                        </div>
                    </FormProvider>
                    { isLoading && (
                        <Box sx={ { display: 'flex', justifyContent: 'center', my: 4 } }>
                            <CircularProgress />
                            <Typography sx={ { ml: 2 } }>Processing your request...</Typography>
                        </Box>
                    ) }
                    { isSubmitted && resultFile && (
                        <Card sx={ { height: '100%', marginTop: '10px', overflow: 'hidden' } }>
                            <CardContent>
                                <Typography variant="h5" sx={ { mb: 2 } }>
                                    <Iconify icon="material-symbols:description" /> Results
                                </Typography>
                                <Box sx={ { display: 'flex', alignItems: 'center', mb: 2 } }>
                                    <Iconify icon="mdi:file-document-outline" width={ 24 } height={ 24 } />
                                    <Typography variant="subtitle1" sx={ { ml: 1 } }>
                                        { fileName || 'wage-determination-results.csv' }
                                    </Typography>
                                </Box>
                                <Box sx={ { my: 3 } }>
                                    <MultiFilePreview
                                        files={ [ resultFile ] }
                                        showPreview={ () => handleViewFile() }
                                        onDownload={ () => handleDownload() }
                                    />
                                </Box>
                                <Box sx={ { mt: 3, display: 'flex', justifyContent: 'flex-end' } }>
                                    <LoadingButton
                                        variant="contained"
                                        className="dark-button"
                                        startIcon={ <Iconify icon="material-symbols:send" /> }
                                        onClick={ handleSendFile }
                                        loading={ isSending }
                                    >
                                        Send File
                                    </LoadingButton>
                                </Box>
                            </CardContent>
                        </Card>
                    ) }
                </CardContent>
            </Card>
        </div>
    );
};
export default TradeWorkTitleCreatePage;